import { render } from "./MainTitle.vue?vue&type=template&id=979e1116&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"

import "./MainTitle.vue?vue&type=style&index=0&id=979e1116&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979e1116"]])

export default __exports__